export class MultiFieldConfig {
	readonly multiline?: boolean;
	readonly minlength?: number;
	readonly maxlength?: number;
	readonly displaylines!: number;
	readonly required?: boolean;
	readonly maxsize?: number;
	readonly allowimageupload?: boolean;
	readonly allowimagegallery?: boolean;
	readonly imagewidth?: number;
	readonly imageheight?: number;
	readonly propshrink?: number;
	readonly propstretch?: number;

	constructor(metadata?: string) {
		this.multiline = false;
		this.displaylines = 5;
		this.minlength = 1;
		this.maxlength = -1;
		this.required = true;
		this.maxsize = 1048576;
		this.allowimageupload = false;
		this.allowimagegallery = true;
		this.imagewidth = undefined;
		this.imageheight = undefined;
		this.propshrink = 75;
		this.propstretch = 100;

		if (metadata) {

			let metadataObj: any | undefined = undefined;
			try {
				metadataObj = JSON.parse(metadata);
			}
			catch (e) {
				console.log("Cannot parse metadata", metadata);
			}

			if (metadataObj.multiline !== undefined) {
				this.multiline = this.parseBoolean(metadataObj.multiline);
			}

			if (metadataObj.displaylines !== undefined) {
				this.displaylines = metadataObj.displaylines;
			}

			if (metadataObj.minlength !== undefined) {
				this.minlength = metadataObj.minlength;
			}

			if (metadataObj.maxlength !== undefined) {
				this.maxlength = metadataObj.maxlength;
			}

			if (metadataObj.required !== undefined) {
				this.required = this.parseBoolean(metadataObj.required);
			}

			if (metadataObj.maxsize !== undefined) {
				this.maxsize = parseInt(metadataObj.maxsize);
			}

			if (metadataObj.allowimageupload !== undefined) {
				this.allowimageupload = this.parseBoolean(metadataObj.allowimageupload);
			}

			if (metadataObj.allowimagegallery !== undefined) {
				this.allowimagegallery = this.parseBoolean(metadataObj.allowimagegallery);
			}

			if (metadataObj.imagewidth !== undefined) {
				this.imagewidth = parseInt(metadataObj.imagewidth);
			}

			if (metadataObj.imageheight !== undefined) {
				this.imageheight = parseInt(metadataObj.imageheight);
			}

			if (metadataObj.propshrink !== undefined) {
				this.propshrink = parseInt(metadataObj.propshrink);
			}

			if (metadataObj.propstretch !== undefined) {
				this.propstretch = parseInt(metadataObj.propstretch);
			}
		}
	}

	private parseBoolean(val: string | boolean): boolean {
		if (!val) {
			return false;
		}

		if (typeof val === "boolean") {
			return val;
		}
		else {
			return String(val).toLowerCase() === "true";
		}
	}
}
